import { useEffect, useState } from 'react';
import { useRequest } from 'loti-request';

import { type ConfigContextState } from 'app/common/ConfigContext';
import { type DisplayContextValue } from 'app/common/DisplayContext';

import {
  getWidgetDisplayMetricsDataState,
  getWidgetDisplayMetricsParams,
  getWidgetDisplayMetricsUrl
} from './utils';

const useWidgetDisplayMetrics = (
  data: ComposedEntityData | undefined,
  error: ErrorType | 'INTEGRATION_ERROR' | null | undefined,
  config: ConfigContextState | undefined,
  displayState: DisplayContextValue | undefined
) => {
  const [widgetDisplayMetricsSent, setWidgetDisplayMetricsSent] = useState(false);

  const { fetch } = useRequest({
    method: 'POST',
    onSuccess: () => {
      setWidgetDisplayMetricsSent(true);
    },
    onError: () => {
      setWidgetDisplayMetricsSent(true);
    }
  });

  useEffect(() => {
    // If the metrics have not already been sent
    if (!widgetDisplayMetricsSent) {
      // Check that we have at least some data or an error
      if (data || error) {
        const url = getWidgetDisplayMetricsUrl();

        if (url) {
          const { block: _block, tab, ...params } = getWidgetDisplayMetricsParams(config);
          const widgetState = getWidgetDisplayMetricsDataState(data, error);

          fetch({
            url,
            body: {
              ...params,
              tabs: tab,
              blocks: {
                requested: displayState?.displayedBlocks,
                loaded: widgetState?.blocksCorrectlyLoaded ?? [],
                failed: widgetState?.blocksFailed ?? []
              },
              widget_state: widgetState?.widgetState
            },
            headers: {
              'Content-Type': 'application/json'
            }
          });
        }
      }
    }
  }, [data, error, config, widgetDisplayMetricsSent]);
};

export { useWidgetDisplayMetrics };
